__turbopack_context__.v({
  "avatar": "Avatar-module-scss-module__KBKOhq__avatar",
  "blue": "Avatar-module-scss-module__KBKOhq__blue",
  "green": "Avatar-module-scss-module__KBKOhq__green",
  "image": "Avatar-module-scss-module__KBKOhq__image",
  "initials": "Avatar-module-scss-module__KBKOhq__initials",
  "lg": "Avatar-module-scss-module__KBKOhq__lg",
  "md": "Avatar-module-scss-module__KBKOhq__md",
  "orange": "Avatar-module-scss-module__KBKOhq__orange",
  "pink": "Avatar-module-scss-module__KBKOhq__pink",
  "sm": "Avatar-module-scss-module__KBKOhq__sm",
  "white": "Avatar-module-scss-module__KBKOhq__white",
  "xl": "Avatar-module-scss-module__KBKOhq__xl",
});
